<template>
	<div>
		<!-- 步骤 -->
		<div class="step">
			<div class="line"></div>
			<div class="item" style="margin-right: 78px;">
				<div class="img">
					<img src="../../assets/image/join/step-active.png">
					<span>1</span>
				</div>
				<div class="text text-active">注册管理员账户</div>
			</div>
			<div class="item" style="margin-right: 93px;">
				<div class="img">
					<img src="../../assets/image/join/step.png" v-if="step<2">
					<img src="../../assets/image/join/step-active.png" v-else>
					<span>2</span>
				</div>
				<div class="text" :class="{'text-active': step>1}">填写入驻申请</div>
			</div>
			<div class="item">
				<div class="img">
					<img src="../../assets/image/join/step.png" v-if="step<3">
					<img src="../../assets/image/join/step-active.png" v-else>
					<span>3</span>
				</div>
				<div class="text" :class="{'text-active': step>2}">信息确认</div>
			</div>
			<div class="item">
				<div class="img">
					<img src="../../assets/image/join/step.png" v-if="step<4">
					<img src="../../assets/image/join/step-active.png" v-else>
					<span>4</span>
				</div>
				<div class="text" :class="{'text-active': step>3}">提交审核</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'djyJoinStep',
		props: ['step']
	}
</script>

<style>
</style>
